import { Fragment, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useBlockUserMutation } from 'store/api/yay/user'
import { Post, User } from 'lib/_types'

import ConfirmBoxBasic from 'components/ConfirmBoxBasic'
import {
  postToPostContextSchema,
  snowplowEvent,
  userToUserContextSchemaData,
} from 'lib/analytics'

const ConfirmBoxBlockUser = ({
  isActive,
  onClose,
  data,
}: {
  isActive: boolean
  onClose: any
  data: {
    user: Partial<User>
    post?: Partial<Post>
    postIndex?: number
    returnPath?: string
    onClose?: Function
  }
}) => {
  const { t } = useTranslation()

  const [__isDone, __isDoneSet] = useState(false)

  const [blockUser] = useBlockUserMutation()

  return (
    <Fragment>
      {(() => {
        const onDone = () => {
          if (data?.onClose) {
            // Close possibly report modal.
            data?.onClose?.()

            // Close itself.
            onClose?.()
            __isDoneSet(false)

            return
          }

          if (data?.returnPath) {
            window.location.href = data?.returnPath
          } else {
            onClose()
          }
        }

        const onOk = () => {
          if (!data.user?.id) return

          blockUser({ userId: data.user.id }).then((res: any) => {
            if (res?.['data']?.result == 'success') {
              snowplowEvent.block_user({
                user: userToUserContextSchemaData({ user: data.user }),
                post: postToPostContextSchema({
                  post: data.post,
                  position:
                    data.postIndex > -1 ? data.postIndex + 1 : undefined,
                }),
              })

              __isDoneSet(true)
              onClose()
            }
          })
        }

        return (
          <ConfirmBoxBasic
            isActive={isActive && !!data.user?.id}
            onClose={onDone}
            onCancel={onDone}
            onOk={onOk}
            title={t('confirm_box_block_user.title')}
            content={t('confirm_box_block_user.body')}
            confirmButtonText={t('common.block')}
          />
        )
      })()}

      {(() => {
        const onDone = () => {
          if (data?.returnPath) {
            window.location.href = data?.returnPath
          } else {
            window.location.reload()
          }
        }

        return (
          <ConfirmBoxBasic
            isActive={__isDone}
            onClose={onDone}
            onOk={onDone}
            title={t('confirm_box_block_user_done.title')}
            content={t('common.you_can_block_on_app')}
          />
        )
      })()}
    </Fragment>
  )
}

export default ConfirmBoxBlockUser
